import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Reactor from 'data/reactor';
import StudentGetters from 'data/student/getters';
import PartnerGetters from 'data/partner/getters';
import ChartUtils from 'utils/chart';

import Chart from './chart';

export default CreateReactClass({
    displayName: 'RainbowChartContainer',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        percentile: PropTypes.number,
        isExpanded: PropTypes.bool.isRequired,
    },

    getChartContainerId(studentBid, subjectBid, type) {
        if (!studentBid || !subjectBid) {
            return null;
        }

        let orientation = this.props.isExpanded ? 'expanded' : 'normal';

        return `rainbow-chart-${studentBid}-${subjectBid}-${type}-${orientation}`;
    },

    render() {
        const chartContainerId = this.getChartContainerId(
            this.props.studentBid,
            this.props.subjectBid,
            this.props.type,
            this.props.isExpanded
        );

        return <Chart chartContainerId={chartContainerId} percentile={this.props.percentile} />;
    },
});
